<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M13.267 13.983 8.883 9.6a3.674 3.674 0 0 1-1.166.675 4.123 4.123 0 0 1-1.417.242c-1.202 0-2.219-.417-3.051-1.25C2.416 8.433 2 7.427 2 6.25c0-1.178.417-2.183 1.25-3.017.833-.833 1.842-1.25 3.025-1.25 1.183 0 2.189.417 3.017 1.25.827.834 1.241 1.84 1.241 3.02a4.149 4.149 0 0 1-.933 2.63L14 13.25l-.733.733ZM6.283 9.517c.903 0 1.67-.32 2.302-.959a3.164 3.164 0 0 0 .948-2.308c0-.9-.316-1.67-.948-2.308a3.117 3.117 0 0 0-2.302-.959c-.912 0-1.687.32-2.325.959A3.148 3.148 0 0 0 3 6.25c0 .9.32 1.67.958 2.308.638.64 1.413.959 2.325.959Z"
        />
    </svg>
</template>

<script setup lang="ts">
type SearchIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<SearchIconProps>();
</script>
